import { z } from 'zod';

export const productSchema = z.object({
  category_id: z
    .string()
    .uuid('declaration:errors.categorySelect')
    .min(1, 'declaration:errors.categoryRequired'),
  subcategory_id: z
    .string()
    .uuid('declaration:errors.subcategorySelect')
    .min(1, 'declaration:errors.subcategoryRequired'),
  full_name: z
    .string()
    .trim()
    .min(2, 'declaration:errors.fullNameRequired')
    .max(200, 'declaration:errors.tooLong'),
  quantity: z.number().int('declaration:errors.quantityInt').min(1, 'declaration:errors.quantityMin'),
  price_per_item: z
    .number()
    .min(0.01, 'declaration:errors.priceMin')
    .max(100_000, 'declaration:errors.priceMax'),
});

export type ProductValues = z.infer<typeof productSchema>;

export type DraftProduct = ProductValues & {
  client_id: string;
  server_id?: string;
};

export const emptyProduct = (): DraftProduct => ({
  client_id:
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `tmp-${Math.random().toString(36).slice(2)}`,
  category_id: '',
  subcategory_id: '',
  full_name: '',
  quantity: 1,
  price_per_item: 0,
});

export const productTotal = (p: ProductValues): number => p.quantity * p.price_per_item;
